import HomeIndex from '../screens/home';
import LoginIndex from '../screens/login';
import LoginConfirm from '../screens/login/confirm';
import BusinessIndex from '../screens/business';
import UserIndex from '../screens/user';
import BusinessDetails from "../screens/business/details";

const routes = [
  {
    path: '/',
    exact: true,
    private: true,
    component: HomeIndex
  },
  {
    path: '/login',
    exact: true,
    private: false,
    component: LoginIndex
  },
  {
    path: '/login/confirm',
    exact: true,
    private: false,
    component: LoginConfirm
  },
  {
    path: '/business',
    exact: true,
    private: true,
    component: BusinessIndex,
  },
  {
    path: '/business/:business_id',
    exact: true,
    private: true,
    component: BusinessDetails,
  },
  {
    path: '/users',
    exact: true,
    private: true,
    component: UserIndex,
  },
];

export default routes;